import { render, staticRenderFns } from "./IngestDocumentViewer.vue?vue&type=template&id=671aa7ed&scoped=true"
import script from "./IngestDocumentViewer.vue?vue&type=script&lang=ts"
export * from "./IngestDocumentViewer.vue?vue&type=script&lang=ts"
import style0 from "./IngestDocumentViewer.vue?vue&type=style&index=0&id=671aa7ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671aa7ed",
  null
  
)

export default component.exports